import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom';

import loader from '../../images/loader.gif';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
// @mui
import { Button, Card, Checkbox, Container, IconButton, MenuItem, Popover, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
// components

import Iconify from '../../common/common-sidebar/components/iconify';
import { BaseURL } from '../../common/URLs';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, GridToolbar, GridToolbarExport } from '@mui/x-data-grid';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { HELPDESK_ROLES } from '../../common/constants';
import { useTranslation } from 'react-i18next';
import { loaderService } from '../../common/custom-loader/loader-service';
import { EditIcon } from '../../common/icons';
import apiClient from '../../axios';

function ManageHelpDeskUserPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = 'Bearer ' + getLocalStorageItem('id_token');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [managefaquserdata, setmanagefaquserdata] = useState([]);
  const rows = [...managefaquserdata];
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalClose = () => setLogModalOpen(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [selectedId, setSelectedId] = useState();

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    managefaquser()
  }, [])
  const managefaquser = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getAllHelpDeskTeamMem",

      {
      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      for (let index = 0; index < response.data.length; index++) {
        let displayName = [response.data[index].firstName, response.data[index].middleName, response.data[index].lastName]
        response.data[index]['fullname'] = displayName?.filter(part => part).join(' ')
        response.data[index]['Category'] = response.data[index].userCategoryList.map(i => i.grievanceCategory).join(', ')
      }
      if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser) {
        let data = response.data.filter(item => item.extFlag === 1);
        setmanagefaquserdata(data)
      }
      else {
        let data = response.data.filter(item => item.extFlag === 0);
        setmanagefaquserdata(data)
      }
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }
  const onConfirmDeleteFaq = () => {
    handleLogModalClose();
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/deleteExistingHelpDeskTeamMemById",

      {
        "id": selectedId,
      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description)
      managefaquser();
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const issueColumns = [
    { field: 'fullname', headerName: t('preReg.name'), width: 200 },
    { field: 'mobile', headerName: 'Mobile', width: 100 },
    { field: 'emailId', headerName: 'Email', width: 250 },
    { field: 'Category', headerName: 'Category', width: 300 },
    {
      field: 'action', headerName: 'Action',
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton size="large" color="primary" onClick={() => { navigate(`ManageHelpDeskedit/${params?.row?.id}`) }}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton size="large" color="error" onClick={(e) => deletefaq(params?.row?.id)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        )
      }
    }
  ]

  const deletefaq = (id) => {
    setSelectedId(id)
    handleLogModalOpen();
  }

  return (
    <>
      <Helmet>
        <title> Manage Helpdesk User | ABEPL </title>
      </Helmet>
      <Container maxWidth="xxl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Manage Helpdesk User
          </Typography>
          <Button component={RouterLink} to='ManageHelpDeskedit' variant="contained" startIcon={<AddIcon />}>
            Add
          </Button>
        </Stack>
        <Card>
          <Box sx={{ height: 400, width: 1 }}>
            <DataGrid
              sx={{
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
              }}
              getRowHeight={() => 'auto'}
              rows={rows}
              columns={issueColumns}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              disableSelectionOnClick
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Card>
        <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmDeleteFaq} action="Delete" onClose={handleLogModalClose} />
      </Container>
    </>
  )
}

export default ManageHelpDeskUserPage